import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    // set initial state of the first link as active
    this.linkTargets[0].classList.add("active-tab");
  }

  handleClick(event) {
    // remove 'active' class from all links except the one that was just clicked
    this.linkTargets.forEach((link) => {
      if (link !== event.currentTarget) {
        link.classList.remove("active-tab");
      }
    });
    // add 'active-tab' class to clicked link
    event.currentTarget.classList.add("active-tab");
  }
}
